/**
 * Video links on a lesson or an SOP step: the client port of the backend media
 * cleaner the lesson (`Knowledge._clean_lesson`) and step (`_clean_steps`)
 * normalisers share. One list, two caps: `MAX_MEDIA` on a lesson,
 * `STEP_MAX_MEDIA` on a step. The server owns the saved shape; this exists so
 * the editor shows what a save will keep and the mock backend stores the same.
 */

/** Mirror of `Constants.LESSON_MEDIA_HOSTS`. */
export const MEDIA_HOSTS = [
    'www.youtube.com',
    'youtube.com',
    'youtu.be',
    'www.youtube-nocookie.com',
    'www.loom.com',
    'loom.com',
    'vimeo.com',
    'player.vimeo.com',
];

export const MEDIA_KINDS = ['youtube', 'loom', 'vimeo'];

export const MAX_MEDIA = 6;
export const STEP_MAX_MEDIA = 3;
export const MAX_MEDIA_URL = 2000;

/** Host of an https URL when it is on the allow-list, else null. */
export const mediaHost = (url) => {
    let parsed;
    try {
        parsed = new URL(String(url || '').trim());
    } catch (e) {
        return null;
    }
    if (parsed.protocol !== 'https:') return null;
    return MEDIA_HOSTS.includes(parsed.hostname) ? parsed.hostname : null;
};

export const isAllowedMediaUrl = (url) => mediaHost(url) !== null;

export const kindForHost = (host) => {
    if (host.includes('youtu')) return 'youtube';
    if (host.includes('loom')) return 'loom';
    return 'vimeo';
};

/** The first `max` links on an allow-listed https host; anything else is dropped, never repaired. */
export const normalizeMedia = (raw, max) => {
    if (!Array.isArray(raw)) return [];
    const out = [];
    raw.forEach((item) => {
        if (!item || typeof item !== 'object') return;
        const url = String(item.url || '').trim();
        // Over the cap the link is refused whole, never cut into a different one.
        if (url.length > MAX_MEDIA_URL) return;
        const host = mediaHost(url);
        if (!host) return;
        out.push({
            kind: MEDIA_KINDS.includes(item.kind) ? item.kind : kindForHost(host),
            url,
            title: String(item.title ?? '').trim(),
        });
    });
    return out.slice(0, max);
};
